import PreviewImages from './PreviewImages';



export default PreviewImages;
